import { render } from "./DocumentTabletFormComponentDetails.vue?vue&type=template&id=d373c37e"
import script from "./DocumentTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__